import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import {
  Button,
  Card,
  CardBody,
  Col,
  Container,
  FormGroup,
  Input,
  Label,
} from "reactstrap";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import ErrorAlert from "../../components/Common/Error/ErrorAlert";
import SuccessAlert from "../../components/Common/Success/SuccessAlert";
import { registerClient, updateClient } from "../../store/client/actions";

export default function RegisterClient() {
  const location = useLocation(); // Get location object from useLocation hook
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [clientData, setClientData] = useState({ name: "", description: "" });
  const [showSuccess, setShowSuccess] = useState(false);
  const [showError, setShowError] = useState(false);
  const [message, setMessage] = useState("");
  const [visible, setVisible] = useState(false);

  const { registrationError } = useSelector(
    (state) => state.clientReducer || {}
  );

  // Check if clientData is passed from the previous screen (via navigate)
  useEffect(() => {
    if (location.state?.clientData) {
      setClientData(location.state.clientData); // Set client data if editing
    }
  }, [location.state]);

  useEffect(() => {
    if (message) {
      setShowSuccess(true);
      setTimeout(() => setShowSuccess(false), 5000);
    }
  }, [message]);

  // Hide error after 5 seconds
  useEffect(() => {
    if (registrationError) {
      setShowError(true);
      const timer = setTimeout(() => {
        setShowError(false); // Hide error after 5 seconds
      }, 5000);

      return () => clearTimeout(timer); // Cleanup timeout on unmount
    }
  }, [registrationError]);

  const showToast = (msg) => {
    setMessage(msg);
    setVisible(true);
    setTimeout(() => setVisible(false), 3000);
  };

  const handleSubmit = () => {
    if (!clientData.name) {
      alert("Name is required");
      return;
    }

    // If there's an id, update the client; otherwise, register a new one
    if (clientData.clientId) {
      dispatch(updateClient(clientData)).then((response) => {
        if (response?.message) {
          // Show success message (optional)
          showToast(response.message);
        }
        // Navigate back after successful update
        navigate("/manage-client"); // Adjust the route as needed
      });
    } else {
      dispatch(registerClient(clientData)).then((response) => {
        if (response?.message) {
          // Show success message (optional)
          showToast(response.message);
        }
        // Navigate back after successful registration
        navigate("/manage-client"); // Adjust the route as needed
      });
    }
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumbs
            title="Control Room"
            breadcrumbItem={
              clientData.clientId ? "Update Client" : "Register Client"
            }
          />
          <Col>
            <Card>
              <CardBody>
                <FormGroup>
                  <Label for="name">Client Name</Label>
                  <Input
                    type="text"
                    name="name"
                    id="name"
                    value={clientData.name}
                    onChange={(e) =>
                      setClientData({ ...clientData, name: e.target.value })
                    }
                  />
                </FormGroup>

                <FormGroup>
                  <Label for="description">Description</Label>
                  <Input
                    type="textarea"
                    name="description"
                    id="description"
                    value={clientData.description}
                    onChange={(e) =>
                      setClientData({
                        ...clientData,
                        description: e.target.value,
                      })
                    }
                  />
                </FormGroup>

                <Button color="primary" onClick={handleSubmit}>
                  {clientData.clientId ? "Update" : "Register"}
                </Button>
                <br />
                <br />
                {showSuccess && <SuccessAlert message={message} />}
                {showError && <ErrorAlert error={registrationError} />}
              </CardBody>
            </Card>
          </Col>
        </Container>
      </div>
    </React.Fragment>
  );
}
